<script>
import diagnosisService from "@/services/diagnosis";
import debounce from "debounce";

const DEBOUNCE_MS_TIMEOUT = 500;
const MIN_SEARCH_LENGTH = 3;

export default {
  name: "DiagnosisSelect",
  props: {
    value: { type: String },
    readonly: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },

  data() {
    return {
      diagnoses: [],
      filterValue: "",
      isLoading: false,
    };
  },

  computed: {
    findDiagnosisById() {
      const diagnosis = this.diagnoses.find((elem) => elem._id === this.value);
      return diagnosis ? diagnosis.description : "Sin datos";
    },
    noDataText() {
      if (
        !this.filterValue ||
        this.filterValue.trim().length < MIN_SEARCH_LENGTH
      )
        return "Ingrese al menos 3 caracteres para buscar";
      return "Sin resultados";
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;
        if (this.diagnoses.find((d) => d._id === newVal)) return;
        const cached = this.$store.state.cacheDiagnoses?.[newVal];
        if (cached) {
          this.diagnoses = [...this.diagnoses, cached];
          return;
        }
        this.getDiagnosisById(newVal);
      },
    },
  },

  methods: {
    async getDiagnosisById(id) {
      try {
        const result = await diagnosisService.getDiagnosisById(id);
        if (result) this.diagnoses = [...this.diagnoses, result];
      } catch (err) {
        console.error("Error fetching diagnosis by id:", err);
      }
    },

    async getDiagnoses(query) {
      this.isLoading = true;
      try {
        const result = await diagnosisService.getDiagnoses({
          featured: false,
          filter: query,
        });
        this.diagnoses = result;
      } catch (err) {
        console.error("Error fetching diagnoses:", err);
      } finally {
        this.isLoading = false;
      }
    },

    debounceSelect: debounce(function (query) {
      this.filterValue = query;
      if (!query || query.trim().length < MIN_SEARCH_LENGTH) {
        this.diagnoses = [];
        this.isLoading = false;
        return;
      }
      this.getDiagnoses(query);
    }, DEBOUNCE_MS_TIMEOUT),

    onInput(value) {
      const selected = this.diagnoses.find((m) => m._id === value);
      if (selected && !this.$store.state.cacheDiagnoses?.[value]) {
        this.$store.dispatch("addDiagnoses", selected);
      }
      this.$emit("input", value);
    },
  },
};
</script>

<template lang="pug">
el-select(
  v-if="!readonly"
  :value="value"
  @input="onInput"
  filterable
  remote
  clearable
  :remote-method="debounceSelect"
  :loading="isLoading"
  :disabled="isDisabled"
  :no-data-text="noDataText"
)
  el-option(
    v-for="item in diagnoses"
    :key="item._id"
    :label="item.description"
    :value="item._id"
  )
    span(style="float: left") {{ item.description }}
    span(v-if="item.featured" style="float: right; color: #8492a6; font-size: 13px") ★

el-input(v-else :value="findDiagnosisById" readonly)
</template>

<style></style>
